export default __webpack_public_path__ + "0b80ffb9553e4fc1571fd0514bca392d.png";